var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduled = function SvgScheduled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".scheduled_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 6,
    className: "scheduled_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.5h-2v-3M9.5 14.5H2A1.5 1.5 0 0 1 .5 13V2A1.5 1.5 0 0 1 2 .5h18A1.5 1.5 0 0 1 21.5 2v7.5",
    className: "scheduled_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.067.946 11 9 .933.946",
    className: "scheduled_svg__a"
  })));
};
export default SvgScheduled;